import type { ResetPasswordResultApi } from '@/domains/user/user.entity';
import type { UserRepository } from '@/domains/user/user.repository';

/**
 * Use Case para resetear la contraseña de un usuario
 *
 * Funcionalidad:
 * Ejecuta el reseteo de contraseña de un usuario del sistema
 *
 * Responsabilidades:
 * - Coordinar con el repositorio para resetear contraseña
 * - Actuar como intermediario entre dominio e infraestructura
 * - Propagar resultado de la operación de reseteo
 */
export class ResetPasswordUserUseCase {
  private repository: UserRepository;

  /**
   * Inicializa el UseCase con el repositorio necesario
   * @param repository - Repositorio para operaciones de usuarios
   */
  constructor(repository: UserRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta el reseteo de contraseña de un usuario
   * @param codFuncioanrio - Código del funcionario al que resetear contraseña
   * @throws Error si falla la operación de reseteo
   */
  async execute(codFuncioanrio: number): Promise<ResetPasswordResultApi> {
    return await this.repository.resetPasswordUser(codFuncioanrio);
  }
}
